var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"image":_vm.getImage,"image-size":_vm.getImageSize,"description":_vm.description}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }